import axios from "@/axios.js";
import lk from "../../http/requests/lookup/index.js";
import photoUpload from "../../http/requests/photo/index.js";
export default {
  getAllShiftType({commit}, payload){
    return new Promise((resolve, reject) => {
      axios.get('/api/lookup/shifttype/getAllShiftType')
      .then((response) => {
        commit("GET_ALL_SHIFTTYPE", response.data.data)
        resolve(response)
      })
      .catch((error) => { return reject(error) })
    })
  },
  getAllScheduleType({commit}, payload){
    return new Promise((resolve, reject) => {
      axios.get('/api/lookup/scheduletype/getAllScheduleType')
      .then((response) => {
        commit("GET_ALL_SCHEDULETYPE", response.data.data)
        resolve(response)
      })
      .catch((error) => { return reject(error) })
    })
  },
  getAllSegmentType({commit}, payload){
    return new Promise((resolve, reject) => {
      axios.get('/api/lookup/segmenttype/getAllSegmentType')
      .then((response) => {
        commit("GET_ALL_SEGMENTTYPE", response.data.data)
        resolve(response)
      })
      .catch((error) => { return reject(error) })
    })
  },
  getAllLeaveTypeLookup({ commit }) {
    return new Promise((resolve, reject) => {
      lk.getAllLeaveTypeLookup()
        .then(response => {
          commit("GET_ALL_LEAVETYPE", response.data.data);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getAllClaimsCategory({ commit }) {
    return new Promise((resolve, reject) => {
      lk.getAllClaimCategory()
        .then(response => {
          commit("GET_ALL_CLAIMCATEGORY", response.data.data);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getAllClaimsSubCategory({ commit }) {
    return new Promise((resolve, reject) => {
      lk.getAllClaimSubCategory()
        .then(response => {
          commit("GET_ALL_CLAIMSUBCATEGORY", response.data.data);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getAllLoanType({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/api/lookup/LoanType/getAllLoanType')
        .then(response => {
          commit("GET_ALL_LOANTYPE", response.data.data);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getAllLoanName({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/api/lookup/LoanName/getAllLoanName')
        .then(response => {
          commit("GET_ALL_LOANNAME", response.data.data);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getAllLoanCategory({ commit }) {
    return new Promise((resolve, reject) => {
      lk.getAllLoanCategory()
        .then(response => {
          commit("GET_ALL_LOANCATEGORY", response.data.data);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getAllLoanSubCategory({ commit }) {
    return new Promise((resolve, reject) => {
      lk.getAllLoanSubCategory()
        .then(response => {
          commit("GET_ALL_LOANSUBCATEGORY", response.data.data);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  addLoanSubCategory({ commit }, items) {
    return new Promise((resolve, reject) => {
        axios.post('/api/lookup/LoanSubCategory/create', items)
          .then((response) => {
            commit('ADD_LoanSubCategory', Object.assign(items, {deductionsTypeId: response.data.data.deductionsTypeId}))
            resolve(response)
          })
          .catch((error) => { reject(error) })
    })
  },
 updateLoanSubCategory({ commit }, items) {
    return new Promise((resolve, reject) => {
        axios.put('/api/lookup/LoanSubCategory/update', items)
          .then((response) => {
            commit('UPDATE_LoanSubCategory', items)
            resolve(response)
          })
          .catch((error) => { reject(error) })
    })
  },
  deleteLoanSubCategory({ commit }, id){
    return new Promise((resolve, reject) => {
      axios.delete(`/api/lookup/LoanSubCategory/${id}`)
        .then((response) => {
          commit('DELETE_LoanSubCategory', id)//Object.assign(item, {employeeFiledLeaveId: response.data.data.employeeFiledLeaveId}))
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  getAllOvertimeType({ commit }) {
    return new Promise((resolve, reject) => {
      lk.getAllOvetimeType()
        .then(response => {
          commit("GET_ALL_OVERTIMETYPE", response.data.data);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getAllDepartment({ commit }) {
    return new Promise((resolve, reject) => {
      lk.getAllDepartment()
        .then(response => {
          //console.log(response.data.data);
          commit("GET_ALL_Department", response.data.data);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getAllCreatePayrollTypeLookup({ commit }) {
    return new Promise((resolve, reject) => {
      lk.getAllCreatePayrollTypeLookup()
        .then(response => {
          //console.log(response.data.data);
          commit("GET_ALL_CreatePayrollType", response.data.data);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getAllBranch({ commit }) {
    return new Promise((resolve, reject) => {
      lk.getAllBranch()
        .then(response => {
          //console.log(response.data.data);
          commit("GET_ALL_Branch", response.data.data);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getAllPosition({ commit }) {
    return new Promise((resolve, reject) => {
      lk.getAllPosition()
        .then(response => {
          //console.log(response.data.data);
          commit("GET_ALL_Position", response.data.data);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getAllDivision({ commit }) {
    return new Promise((resolve, reject) => {
      lk.getAllDivision()
        .then(response => {
          //console.log(response.data.data);
          commit("GET_ALL_Division", response.data.data);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getAllSection({ commit }) {
    return new Promise((resolve, reject) => {
      lk.getAllSection()
        .then(response => {
          //console.log(response.data.data);
          commit("GET_ALL_Section", response.data.data);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getAllEmployeeCategory({ commit }) {
    return new Promise((resolve, reject) => {
      lk.getAllEmployeeCategory()
        .then(response => {
          //console.log('CATEGORY EMPLOYEE')
          //console.log(response.data.data);
          commit("GET_ALL_EmployeeCategory", response.data.data);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getAllEarningsType({ commit }) {
    return new Promise((resolve, reject) => {
      lk.getAllEarningsType()
        .then(response => {
          //console.log(response.data.data);
          commit("GET_ALL_EarningsType", response.data.data);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  addEarningsType({ commit }, items) {
    return new Promise((resolve, reject) => {
        axios.post('/api/lookup/EarningsType/create', items)
          .then((response) => {
            commit('ADD_EarningsType', Object.assign(items, {earningsTypeId: response.data.data.earningsTypeId}))
            resolve(response)
          })
          .catch((error) => { reject(error) })
    })
  },
 updateEarningsType({ commit }, items) {
    return new Promise((resolve, reject) => {
        axios.put('/api/lookup/EarningsType/update', items)
          .then((response) => {
            commit('UPDATE_EarningsType', items)
            resolve(response)
          })
          .catch((error) => { reject(error) })
    })
  },
  deleteEarningsType({ commit }, id){
    return new Promise((resolve, reject) => {
      axios.delete(`/api/lookup/EarningsType/${id}`)
        .then((response) => {
          commit('DELETE_EarningsType', response.data.data)//Object.assign(item, {employeeFiledLeaveId: response.data.data.employeeFiledLeaveId}))
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  getAllEarningsCategory({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/api/lookup/EarningsCategory/getAllEarningsCategory')
        .then(response => {
          commit("GET_ALL_EarningsCategory", JSON.parse(JSON.stringify(response.data.data)))
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getAllDeductionsType({ commit }) {
    return new Promise((resolve, reject) => {
      lk.getAllDeductionsType()
        .then(response => {
          //console.log(response.data.data);
          commit("GET_ALL_DeductionsType", response.data.data);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  addDeductionsType({ commit }, items) {
    return new Promise((resolve, reject) => {
        axios.post('/api/lookup/DeductionsType/create', items)
          .then((response) => {
            commit('ADD_DeductionsType', Object.assign(items, {deductionsTypeId: response.data.data.deductionsTypeId}))
            resolve(response)
          })
          .catch((error) => { reject(error) })
    })
  },
 updateDeductionsType({ commit }, items) {
    return new Promise((resolve, reject) => {
        axios.put('/api/lookup/DeductionsType/update', items)
          .then((response) => {
            commit('UPDATE_DeductionsType', items)
            resolve(response)
          })
          .catch((error) => { reject(error) })
    })
  },
  deleteDeductionsType({ commit }, id){
    return new Promise((resolve, reject) => {
      axios.delete(`/api/lookup/DeductionsType/${id}`)
        .then((response) => {
          commit('DELETE_DeductionsType', id)//Object.assign(item, {employeeFiledLeaveId: response.data.data.employeeFiledLeaveId}))
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  getAllDeductionsCategory({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/api/lookup/DeductionsCategory/getAllDeductionsCategory')
        .then(response => {
          commit("GET_ALL_DeductionsCategory", JSON.parse(JSON.stringify(response.data.data)))
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getAllCivilStatus({ commit }) {
    return new Promise((resolve, reject) => {
      lk.getAllCivilStatus()
        .then(response => {
          //console.log(response.data.data);
          commit("GET_ALL_CivilStatus", response.data.data);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getAllNationality({ commit }) {
    return new Promise((resolve, reject) => {
      lk.getAllNationality()
        .then(response => {
          //console.log(response.data.data);
          commit("GET_ALL_Nationality", response.data.data);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getAllReligion({ commit }) {
    return new Promise((resolve, reject) => {
      lk.getAllReligion()
        .then(response => {
          //console.log(response.data.data);
          commit("GET_ALL_Religion", response.data.data);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getAllRelationshipLookup({ commit }) {
    return new Promise((resolve, reject) => {
      lk.getAllRelationshipLookup()
        .then(response => {
          //console.log(response.data.data);
          commit("GET_ALL_Relationship", response.data.data);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getAllAccreditationType({ commit }) {
    return new Promise((resolve, reject) => {
      lk.getAllAccreditationType()
        .then(response => {
          //console.log(response.data.data);
          commit("GET_ALL_AccreditationType", response.data.data);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getAllRankLookup({ commit }) {
    return new Promise((resolve, reject) => {
      lk.getAllRankLookup()
        .then(response => {
          //console.log(response.data.data);
          commit("GET_ALL_Rank", response.data.data);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getAllAssociationLookup({ commit }) {
    return new Promise((resolve, reject) => {
      lk.getAllAssociationLookup()
        .then(response => {
          //console.log(response.data.data);
          commit("GET_ALL_Association", response.data.data);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getAllBankLookup({ commit }) {
    return new Promise((resolve, reject) => {
      lk.getAllBankLookup()
        .then(response => {
          //console.log(response.data.data);
          commit("GET_ALL_Bank", response.data.data);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  getAllPeriodLookup({ commit }) {
    return new Promise((resolve, reject) => {
      lk.getAllPeriodLookup()
        .then(response => {
          //console.log(response.data.data);
          commit("GET_ALL_Period", response.data.data);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getAllBenefitTypeLookup({ commit }) {
    return new Promise((resolve, reject) => {
      lk.getAllBenefitTypeLookup()
        .then(response => {
          //console.log(response.data.data);
          commit("GET_ALL_BenefitType", response.data.data);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getAllLineOfBusinessLookup({ commit }) {
    return new Promise((resolve, reject) => {
      lk.getAllLineOfBusinessLookup()
        .then(response => {
          //console.log(response.data.data);
          commit("GET_ALL_LineOfBusiness", response.data.data);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getAllDegreeLookup({ commit }) {
    return new Promise((resolve, reject) => {
      lk.getAllDegreeLookup()
        .then(response => {
          //console.log(response.data.data);
          commit("GET_ALL_Degree", response.data.data);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getAllAreaOfStudyLookup({ commit }) {
    return new Promise((resolve, reject) => {
      lk.getAllAreaOfStudyLookup()
        .then(response => {
          //console.log(response.data.data);
          commit("GET_ALL_AreaOfStudy", response.data.data);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getAllInstitutionLookup({ commit }) {
    return new Promise((resolve, reject) => {
      lk.getAllInstitutionLookup()
        .then(response => {
          //console.log(response.data.data);
          commit("GET_ALL_Institution", response.data.data);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getAllAwardLookup({ commit }) {
    return new Promise((resolve, reject) => {
      lk.getAllAwardLookup()
        .then(response => {
          //console.log(response.data.data);
          commit("GET_ALL_Award", response.data.data);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getAllAppraisalTypeLookup({ commit }) {
    return new Promise((resolve, reject) => {
      lk.getAllAppraisalTypeLookup()
        .then(response => {
          //console.log(response.data.data);
          commit("GET_ALL_AppraisalType", response.data.data);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getAllMarketSegmentLookup({ commit }) {
    return new Promise((resolve, reject) => {
      lk.getAllMarketSegmentLookup()
        .then(response => {
          //console.log(response.data.data);
          commit("GET_ALL_MarketSegment", response.data.data);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getAllAppraisalRatingLookup({ commit }) {
    return new Promise((resolve, reject) => {
      lk.getAllAppraisalRatingLookup()
        .then(response => {
          //console.log(response.data.data);
          commit("GET_ALL_AppraisalRating", response.data.data);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  getAllSalaryBasedOnLookup({ commit }) {
    return new Promise((resolve, reject) => {
      lk.getAllSalaryBasedOnLookup()
        .then(response => {
          //console.log(response.data.data);
          commit("GET_ALL_SalaryBasedOn", response.data.data);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getAllScheduleNumber({ commit }) {
    return new Promise((resolve, reject) => {
      lk.getAllScheduleNumber()
        .then(response => {
          //console.log(response.data.data);
          commit("GET_ALL_ScheduleNumber", response.data.data);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getAllTaxReferenceLookup({ commit }) {
    return new Promise((resolve, reject) => {
      lk.getAllTaxReferenceLookup()
        .then(response => {
          //console.log(response.data.data);
          commit("GET_ALL_TaxReference", response.data.data);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getAllPaymentModeLookup({ commit }) {
    return new Promise((resolve, reject) => {
      lk.getAllPaymentModeLookup()
        .then(response => {
          //console.log(response.data.data);
          commit("GET_ALL_PaymentMode", response.data.data);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getAllViolationLookup({ commit }) {
    return new Promise((resolve, reject) => {
      lk.getAllViolationLookup()
        .then(response => {
          //console.log(response.data.data);
          commit("GET_ALL_Violation", response.data.data);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getAllViolationActionLookup({ commit }) {
    return new Promise((resolve, reject) => {
      lk.getAllViolationActionLookup()
        .then(response => {
          //console.log(response.data.data);
          commit("GET_ALL_ViolationAction", response.data.data);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getAllMedicalProcedureLookup({ commit }) {
    return new Promise((resolve, reject) => {
      lk.getAllMedicalProcedureLookup()
        .then(response => {
          //console.log(response.data.data);
          commit("GET_ALL_MedicalProcedure", response.data.data);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getAllCountryLookup({ commit }, source) {
    return new Promise((resolve, reject) => {
      lk.getAllCountryLookup(source)
        .then(response => {
          let country =[]
          for (var c = 0; c < response.data.length; c++ ){
              if(response.data[c].countryCode != this.countryCode)
              {
                this.countryCode = response.data[c].countryCode
                country.push(response.data[c])
              }
          }
          commit("GET_ALL_Country", country);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
};
